import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import blueFilledLogo from './images/yoco_logo_blue.svg'
import whiteFilledLogo from './images/yoco_logo_white.svg'

const LogoImage = styled.img`
  width: 100%;
`

const Logo = ({ image }) => {
  return <LogoImage src={image} />
}

Logo.image = {
  blueFilled: blueFilledLogo,
  whiteFilled: whiteFilledLogo,
}

Logo.propTypes = {
  image: PropTypes.string,
}

Logo.defaultProps = {
  image: Logo.image.blueFilled,
}

export default Logo



// WEBPACK FOOTER //
// ./includes/yoco-website-cms-gatsby/src/components/brand/Logo/Logo.js